// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 운영 도구 - 지점 선택 페이지 스타일
 * VIP 퍼플 테마
 */

.store-select-page {
  min-height: 100vh;
  background: linear-gradient(170deg, #F3E5F5 0%, #FFF8E1 50%, #F8F4E8 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 배경 장식 */
.store-deco {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.store-deco-1 {
  top: -100px;
  right: -100px;
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(123, 31, 162, 0.1) 0%, transparent 70%);
}

.store-deco-2 {
  bottom: -80px;
  left: -80px;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.1) 0%, transparent 70%);
}

/* 상단 바 */
.store-top-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 32px;
  gap: 16px;
  z-index: 1;
}

.store-top-user {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  color: #555;
  font-weight: 500;
}

.store-btn-logout {
  padding: 8px 20px;
  font-size: 15px;
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 500;
  color: #7B1FA2;
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid #CE93D8;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  min-height: 40px;
}

.store-btn-logout:hover {
  background: #E1BEE7;
}

/* 컨텐츠 */
.store-select-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  z-index: 1;
  animation: storesFadeIn 0.5s ease-out;
}

@keyframes storesFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 헤더 */
.store-select-header {
  text-align: center;
  margin-bottom: 40px;
}

.store-select-icon {
  font-size: 64px;
  display: block;
  margin-bottom: 12px;
}

.store-select-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 40px;
  color: #7B1FA2;
  margin: 0;
  letter-spacing: 2px;
}

.store-select-sub {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  color: #9C27B0;
  margin-top: 8px;
  font-weight: 500;
}

/* 지점 카드 그리드 */
.store-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 900px;
}

/* 지점 카드 */
.store-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 28px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border: 3px solid rgba(123, 31, 162, 0.12);
  border-radius: 24px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  box-shadow: 0 4px 20px rgba(123, 31, 162, 0.08);
  text-align: center;
  min-height: 180px;
  font-family: 'Noto Sans KR', sans-serif;
}

.store-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(123, 31, 162, 0.18);
  border-color: #7B1FA2;
}

.store-card:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.12);
}

.store-card-icon {
  font-size: 48px;
  line-height: 1;
}

.store-card-name {
  font-family: 'Jua', sans-serif;
  font-size: 26px;
  color: #333;
  margin: 0;
}

.store-card-address {
  font-size: 14px;
  color: #888;
  margin: 0;
}

/* 로딩 */
.store-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #7B1FA2;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
}

.store-spinner {
  display: inline-block;
  width: 36px;
  height: 36px;
  border: 4px solid rgba(123, 31, 162, 0.2);
  border-top-color: #7B1FA2;
  border-radius: 50%;
  animation: storeSpin 0.8s linear infinite;
}

@keyframes storeSpin {
  to { transform: rotate(360deg); }
}

/* 에러 */
.store-error {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 28px;
  background: #fff5f5;
  border: 2px solid #ffc9c9;
  border-radius: 16px;
  font-family: 'Noto Sans KR', sans-serif;
}

.store-error span {
  font-size: 24px;
}

.store-error p {
  margin: 0;
  font-size: 18px;
  color: #c92a2a;
  font-weight: 500;
}

/* 빈 목록 */
.store-empty {
  text-align: center;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  color: #999;
  padding: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StoreSelectPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAIF;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gFAAgF;AAClF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,8DAA8D;EAC9D,+CAA+C;EAC/C,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,WAAW;EACX,aAAa;AACf","sourcesContent":["/**\n * 운영 도구 - 지점 선택 페이지 스타일\n * VIP 퍼플 테마\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap');\n\n.store-select-page {\n  min-height: 100vh;\n  background: linear-gradient(170deg, #F3E5F5 0%, #FFF8E1 50%, #F8F4E8 100%);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 배경 장식 */\n.store-deco {\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.store-deco-1 {\n  top: -100px;\n  right: -100px;\n  width: 350px;\n  height: 350px;\n  background: radial-gradient(circle, rgba(123, 31, 162, 0.1) 0%, transparent 70%);\n}\n\n.store-deco-2 {\n  bottom: -80px;\n  left: -80px;\n  width: 280px;\n  height: 280px;\n  background: radial-gradient(circle, rgba(212, 175, 55, 0.1) 0%, transparent 70%);\n}\n\n/* 상단 바 */\n.store-top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 16px 32px;\n  gap: 16px;\n  z-index: 1;\n}\n\n.store-top-user {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 16px;\n  color: #555;\n  font-weight: 500;\n}\n\n.store-btn-logout {\n  padding: 8px 20px;\n  font-size: 15px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-weight: 500;\n  color: #7B1FA2;\n  background: rgba(255, 255, 255, 0.8);\n  border: 2px solid #CE93D8;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  min-height: 40px;\n}\n\n.store-btn-logout:hover {\n  background: #E1BEE7;\n}\n\n/* 컨텐츠 */\n.store-select-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 32px;\n  z-index: 1;\n  animation: storesFadeIn 0.5s ease-out;\n}\n\n@keyframes storesFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 헤더 */\n.store-select-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.store-select-icon {\n  font-size: 64px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.store-select-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 40px;\n  color: #7B1FA2;\n  margin: 0;\n  letter-spacing: 2px;\n}\n\n.store-select-sub {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 18px;\n  color: #9C27B0;\n  margin-top: 8px;\n  font-weight: 500;\n}\n\n/* 지점 카드 그리드 */\n.store-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n  width: 100%;\n  max-width: 900px;\n}\n\n/* 지점 카드 */\n.store-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px 28px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n  border: 3px solid rgba(123, 31, 162, 0.12);\n  border-radius: 24px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n  box-shadow: 0 4px 20px rgba(123, 31, 162, 0.08);\n  text-align: center;\n  min-height: 180px;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.store-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(123, 31, 162, 0.18);\n  border-color: #7B1FA2;\n}\n\n.store-card:active {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.12);\n}\n\n.store-card-icon {\n  font-size: 48px;\n  line-height: 1;\n}\n\n.store-card-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 26px;\n  color: #333;\n  margin: 0;\n}\n\n.store-card-address {\n  font-size: 14px;\n  color: #888;\n  margin: 0;\n}\n\n/* 로딩 */\n.store-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: #7B1FA2;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 18px;\n}\n\n.store-spinner {\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  border: 4px solid rgba(123, 31, 162, 0.2);\n  border-top-color: #7B1FA2;\n  border-radius: 50%;\n  animation: storeSpin 0.8s linear infinite;\n}\n\n@keyframes storeSpin {\n  to { transform: rotate(360deg); }\n}\n\n/* 에러 */\n.store-error {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 28px;\n  background: #fff5f5;\n  border: 2px solid #ffc9c9;\n  border-radius: 16px;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.store-error span {\n  font-size: 24px;\n}\n\n.store-error p {\n  margin: 0;\n  font-size: 18px;\n  color: #c92a2a;\n  font-weight: 500;\n}\n\n/* 빈 목록 */\n.store-empty {\n  text-align: center;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 18px;\n  color: #999;\n  padding: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
